"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Webgl = void 0;
const three_1 = require("three");
const camera_js_1 = require("./components/camera.js");
const lights_js_1 = require("./components/lights.js");
const renderer_js_1 = require("./services/renderer.js");
const controls_js_1 = require("./services/controls.js");
const Loop_js_1 = require("./services/Loop.js");
const modelLoader_js_1 = require("../../loaders/modelLoader.js");
const cssrenderer_js_1 = require("./services/cssrenderer.js");
const fitToScreen_js_1 = require("./services/fitToScreen.js");
const materislCorrection_js_1 = require("./services/materislCorrection.js");
const config_js_1 = require("../../config.js");
const nexus_viewer_lib_1 = require("nexus-viewer-lib");
const modelType_js_1 = require("../../enums/modelType.js");
const SceneOverride_js_1 = require("../../api/objects/SceneOverride.js");
const modelFormat_js_1 = require("../../enums/modelFormat.js");
const Lights_js_1 = require("./services/Lights.js");
const memoryFree_js_1 = require("./services/memoryFree.js");
const nexusRemove_js_1 = require("./services/nexusRemove.js");
const ModelTransform_js_1 = require("./services/ModelTransform.js");
class Webgl {
    constructor(container, annotationLayer) {
        this._managableObjects = [];
        this._loadedObjectsIds = [];
        this._sceneOverride = new SceneOverride_js_1.SceneOverride();
        this.isNexusModel = false;
        this.webglFunctions = {
            controlStart: () => this.startRendering(),
            controlEnd: () => this.stopRendering(),
            controlWhell: () => this.renderOnce(),
        };
        this._camera = (0, camera_js_1.createPerspectiveCamera)();
        this._renderer = (0, renderer_js_1.createRenderer)();
        this._scene = new three_1.Scene();
        this._cssRenderer = (0, cssrenderer_js_1.createCssRenderer)(annotationLayer);
        // TODO: create new Controls class move this in and handle events there...
        this._orbitControls = (0, controls_js_1.createOrbitControls)(this._camera, this._renderer.domElement);
        this._orbitControls.addEventListener('start', this.webglFunctions.controlStart);
        this._orbitControls.addEventListener('end', this.webglFunctions.controlEnd);
        document.addEventListener('wheel', this.webglFunctions.controlWhell);
        this._loop = new Loop_js_1.Loop(this._camera, this._scene, this._renderer, this._orbitControls, this._cssRenderer);
        this._lights = new Lights_js_1.Lights(this);
        container.append(this._renderer.domElement);
        annotationLayer.append(this._cssRenderer.domElement);
        this.addObject((0, lights_js_1.createAmbientLight)(config_js_1.config.webgl.lights.ambient.color, config_js_1.config.webgl.lights.ambient.intensity));
        this.setSize(container);
        this.renderOnce();
        this.modelTransformService = new ModelTransform_js_1.ModelTransformService(this);
    }
    static getInstance() {
        if (!Webgl.instance) {
            const webglLayer = document.getElementsByClassName('webgl-layer')[0];
            const annotationLayer = document.getElementsByClassName('annotation-layer')[0];
            Webgl.instance = new Webgl(webglLayer, annotationLayer);
        }
        return Webgl.instance;
    }
    get camera() { return this._camera; }
    set camera(camera) { this._camera = camera; }
    get renderer() { return this._renderer; }
    set renderer(renderer) { this._renderer = renderer; }
    get scene() { return this._scene; }
    set scene(scene) { this.scene = scene; }
    get loop() { return this._loop; }
    set loop(loop) { this._loop = loop; }
    get lights() { return this._lights; }
    set lights(lights) { this._lights = lights; }
    get orbitControls() { return this._orbitControls; }
    set orbitControls(orbitControls) { this._orbitControls = orbitControls; }
    get managableObjects() { return this._managableObjects; }
    set managableObjects(managableObjects) { this._managableObjects = managableObjects; }
    get loadedObjectsIds() { return this._loadedObjectsIds; }
    set loadedObjectsIds(loadedObjectsIds) { this._loadedObjectsIds = loadedObjectsIds; }
    get selected() { return this._selected; }
    set selected(selected) { this._selected = selected; }
    get sceneOverride() { return this._sceneOverride; }
    set sceneOverride(sceneOverride) { this._sceneOverride = sceneOverride; }
    dispose() {
        var _a, _b;
        this.stopRendering();
        // TODO: create new Controls class move this in and handle events there...
        this.orbitControls.removeEventListener('start', this.webglFunctions.controlStart);
        this.orbitControls.removeEventListener('end', this.webglFunctions.controlEnd);
        document.removeEventListener('wheel', this.webglFunctions.controlWhell);
        this.removeObject(this.scene);
        if (this.isNexusModel) {
            this.isNexusModel = false;
            (0, nexusRemove_js_1.removeNexusObject)(this._renderer);
        }
        this.scene.clear();
        this.loop.dispose();
        this.orbitControls.dispose();
        this.renderer.renderLists.dispose();
        this.renderer.dispose();
        this.managableObjects = [];
        this.loadedObjectsIds = [];
        delete this.selected;
        (_a = this.renderer.domElement.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(this.renderer.domElement);
        (_b = this._cssRenderer.domElement.parentElement) === null || _b === void 0 ? void 0 : _b.removeChild(this._cssRenderer.domElement);
        Webgl.instance = undefined;
    }
    // Resize
    resize(container) {
        this.setSize(container);
        this._cssRenderer.setSize(container.clientWidth, container.clientHeight);
        this.renderOnce();
    }
    // Render one frame
    renderOnce() {
        if (nexus_viewer_lib_1.Nexus.getContext(this._renderer.getContext()).state.nodesPending != 0) {
            PubSub.publish("toggle-loading-display" /* TOGGLE_LOADING_DISPLAY */, true);
        }
        else {
            PubSub.publish("toggle-loading-display" /* TOGGLE_LOADING_DISPLAY */, false);
        }
        if (this.isNexusModel) {
            nexus_viewer_lib_1.Nexus.beginFrame(this._renderer.getContext());
        }
        this._orbitControls.update();
        this._renderer.render(this._scene, this._camera);
        this._cssRenderer.render(this._scene, this._camera);
        if (this.isNexusModel) {
            nexus_viewer_lib_1.Nexus.endFrame(this._renderer.getContext());
        }
    }
    // Start rendering
    startRendering() {
        this._loop.start();
    }
    // Stop rendering
    stopRendering() {
        this._loop.stop();
    }
    // Add object to scene
    addObject(object, managable = false) {
        this._scene.add(object);
        if (managable) {
            this._managableObjects.push(object);
        }
        this.renderOnce();
    }
    // Remove object from scene
    removeObject(object) {
        // TODO: check scene before delete...
        //        if (object.parent === null) return; // avoid deleting the camera or scene
        var _a;
        if (object.children.length > 0) {
            object.children.forEach((child) => (0, memoryFree_js_1.freeObjectFromMemory)(child));
            object.remove(...object.children);
        }
        (0, memoryFree_js_1.freeObjectFromMemory)(object);
        (_a = object.parent) === null || _a === void 0 ? void 0 : _a.remove(object);
        const idx = this._managableObjects.findIndex(item => item.uuid === object.uuid);
        if (idx !== -1) {
            this._managableObjects.splice(idx, 1);
        }
        this.renderOnce();
    }
    // Load model
    loadModel(url, model, tokenProvider, qualityType) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const modelType = model.type;
            const modelFormat = model.format;
            const loader = new modelLoader_js_1.ModelLoader(modelType, modelFormat);
            const loaded = yield loader.load(url, this, tokenProvider);
            if (modelType === modelType_js_1.ModelType.MODEL_TYPE_IMAGE_360) {
                const loadedImage = loaded;
                const rt = new three_1.WebGLCubeRenderTarget(loadedImage.image.height);
                rt.fromEquirectangularTexture(this._renderer, loadedImage);
                this._scene.background = rt.texture;
            }
            else {
                const loadedModel = loaded;
                const result = (_a = this.sceneOverride) === null || _a === void 0 ? void 0 : _a.models.find((modelOverride) => modelOverride.modelId === model.modelId);
                if (result) {
                    loadedModel.position.set(result.position.x, result.position.y, result.position.z);
                    loadedModel.rotation.set(result.rotation.x, result.rotation.y, result.rotation.z);
                    loadedModel.scale.set(result.scale.x, result.scale.y, result.scale.z);
                }
                (0, materislCorrection_js_1.materialCorrection)(loadedModel);
                switch (modelFormat) {
                    case modelFormat_js_1.ModelFormat.MODEL_FORMAT_GLTF:
                        if ("low" /* LOW */ === qualityType) {
                            loadedModel.name = "low" /* LOW */;
                            (0, fitToScreen_js_1.fitToScreen)(loadedModel, this.camera, this.orbitControls);
                        }
                        if ("high" /* HIGH */ === qualityType) {
                            const lowModel = this._scene.getObjectByName("low" /* LOW */);
                            const lowModelUuid = lowModel === null || lowModel === void 0 ? void 0 : lowModel.uuid;
                            if (lowModel) {
                                this.removeObject(lowModel);
                            }
                            const idx = this._loadedObjectsIds.findIndex((stringKeyVal) => stringKeyVal.val === lowModelUuid);
                            if (idx !== -1) {
                                this._loadedObjectsIds.splice(idx, 1);
                            }
                        }
                        break;
                    case modelFormat_js_1.ModelFormat.MODEL_FORMAT_NEXUS:
                        this.isNexusModel = true;
                        (0, fitToScreen_js_1.fitToScreen)(loadedModel, this.camera, this.orbitControls);
                        break;
                    default: throw new Error("Unsuported model format: " + modelFormat);
                }
                this.addObject(loadedModel, true);
                this._loadedObjectsIds.push({ key: model.modelId, val: loadedModel.uuid });
            }
            this.renderOnce();
        });
    }
    setSize(container) {
        this._camera.aspect = container.clientWidth / container.clientHeight; // Set the camera's aspect ratio
        this._camera.updateProjectionMatrix(); // Update the camera's frustum
        this._renderer.setSize(container.clientWidth, container.clientHeight); // Update the size of the renderer AND the canvas
        this._renderer.setPixelRatio(window.devicePixelRatio); // Set the pixel ratio (for mobile devices)
        this.checkForMobile(container.clientWidth);
    }
    checkForMobile(width) {
        const menu = document.getElementById('miniMenu');
        const compass = document.getElementsByClassName('compass-cursor')[0];
        if (!compass || !menu) {
            return;
        }
        if (width > 600) {
            menu === null || menu === void 0 ? void 0 : menu.removeAttribute('mobile');
            menu.style.width = '';
            compass.style.left = '';
            compass.style.right = '';
            return;
        }
        compass.style.right = '30px';
        compass.style.left = 'unset';
        // set menu width to guiLayer height
        const layer = document.getElementById('guiLayer');
        menu.style.width = (layer === null || layer === void 0 ? void 0 : layer.clientHeight) + 'px';
        menu === null || menu === void 0 ? void 0 : menu.setAttribute('mobile', 'true');
    }
}
exports.Webgl = Webgl;
